module.exports = __webpack_public_path__ + "static/media/envelope-star.ac0429f4.svg";